<template>
  <div class="container">
    <div class="logo">付款成功后，{{orderInfo.allMinute}}分钟内未到账，请立即联系客服！</div>
    <div class="box_top">
      <img src="../images/box_top.png" />
    </div>
    <div class="box">
      <h2 id="orderSN_data">
        <span class="orderSN_data_No">
          支付金额：
          <span>{{orderInfo.realMoney}}</span>
        </span>
        <span
          class="orderSN_data_copy btn"
          style="display: inline-block;height: 100%;line-height: 100%; width: 20%;font-size: 15px;color: #f40101;"
          :data-clipboard-text="orderInfo.realMoney"
        >复制金额</span>
      </h2>
      <h2 id="orderName">
        <span class="orderSN_data_No">
          姓名:
          <span style="color: red; ">【{{orderInfo.realName}}】</span>
        </span>
      </h2>
      <h2 id="orderSN_data">
        <span class="orderSN_data_No">
          订单号：
          <span>{{orderInfo.orderId}}</span>
        </span>
        <span class="orderSN_data_copy btn" :data-clipboard-text="orderInfo.orderId">复制</span>
      </h2>
    </div>
    <div>
      <img src="../images/box_middle.png" />
    </div>
    <div class="box h300" style="padding:1px 0">
      <div class="tips" style="margin-bottom: 10px">
        <p style="margin: 0px; font-size: 15px; font-weight: bold; color: #01a9f4">
          请勿修改金额付款 →
          <span>点击立即支付</span>
        </p>
      </div>
      <div class="qrcode_box" style="position:relative">
        <div
          id="qrcode"
          style="display: block; width: 210px; height: 210px;background:url(../images/qrcode_loading.png) center top;"
        >
          <div id="qrCode" ref="qrCodeDiv" v-if="!orderInfo.isPay"></div>
          <div v-else>
              <img src="../images/pay_ok.png" style="width:210px;height:210px" alt="">
          </div>
        </div>

        <div id="loading" style="display: none;">
          <span class="loading"></span>
          <span class="load-text">正在载入二维码...</span>
        </div>
      </div>
      <span class="tip">请在下面时间内完成付款</span>
      <div id="tipText" style="width: 100%; height: 56px; margin-top: 15px;">
        <div
          id="showtext"
          style="line-height: 56px; height: 56px; width: 80%; float: left; text-align: left; padding-left: 2%; font-size: 18px;"
        >
          <a target="_bank" :href="orderInfo.jumpUrl" style>
            <span
              style="width: 100px;
        height: 40px;
        line-height: 40px; /* margin-top: 8px; */
        border-radius: 5px;
        color: white;
        background: #f40101;
        display: block;
        text-align: center;
        margin-left: 8rem;"
            >立即支付</span>
          </a>
        </div>
      </div>

      <div class="ico-scan_alipay_qr"></div>
      <div class="time">
        <strong id="minute_show" style="background:#01a9f4">
          <s></s>
          {{MM}}
        </strong>
        <span class="time_dot" style="color:#01a9f4">:</span>
        <strong id="second_show" style="background:#01a9f4">
          <s></s>
          {{ss}}
        </strong>
      </div>

      <div id="leftCaption">
        <span class="leftCaption1">请勿修改金额付款</span>
        <span class="leftCaption2">，否则不到账</span>
      </div>
      <div id="rightCaption">
        <span class="rightCaption1">请勿重复支付付款</span>
        <span class="rightCaption2">，否则不到账</span>
      </div>
    </div>
    <div>
      <img src="../images/box_bottom.png" />
    </div>
  </div>
</template>
<script>
let Base64 = require("js-base64").Base64;
let axios = require("axios");
import QRCode from "qrcodejs2";
import Clipboard from "clipboard";

export default {
  name: "pay",
  data() {
    return {
      param: {},
      orderInfo: {},
      MM: "00",
      ss: "00",
      timer: 0,
      timer2: 0
    };
  },
  created() {
    var self = this;
    var param = this.$route.query;
    var data = [];
    for (const i in param) {
      var item = param[i];
      item = Base64.decode(decodeURI(item));
      if (item && item.indexOf("|") >= 0) {
        item = item.split("|")[0];
      }
      data.push(item);
    }
    var url = `${data[0]}/Facade/GetMecOrderInfo?orderid=${data[1]}`;
    axios
      .get(url)
      .then(function(response) { 

        if (response.data && response.data.result && response.data.code == 1) {
          self.orderInfo = response.data.result;
          self.orderInfo.allMinute = self.orderInfo.timeAllCount / 60;
          self.orderInfo.isPay = false; 
          self.$nextTick(function() {
            self.bindQRCode(self.orderInfo.qrCode);
          });
          self.setTimer(self.orderInfo.timeAllCount);
          self.getMemberOrderStatus(data)
          new Clipboard(".btn").on("success", function() {
            alert("复制成功！");
          });
        }
      }) 
  },
  methods: {
    bindQRCode: function(url) {
      new QRCode(this.$refs.qrCodeDiv, {
        text: url,
        width: 210,
        height: 210,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
      });
    },
    setTimer: function(time) {
      var self = this;
      self.MM = self.setDouString(parseInt(time / 60));
      self.ss = self.setDouString(time % 60);
      self.timer = setInterval(() => {
        time--;
        if (time == 0) {
          self.MM = "00";
          self.ss = "00";
          clearInterval(self.timer);
        }
        self.MM = self.setDouString(parseInt(time / 60));
        self.ss = self.setDouString(time % 60);
      }, 1000);
    },
    setDouString: function(num) {
      return num < 10 ? "0" + num : num;
    },
    getMemberOrderStatus: function(data) {
      var self = this;
      var url = `${data[0]}/PayHelper/GetMemberOrderStatus`;
      self.timer2 = setInterval(() => {
        axios
          .post(url,'orderid='+this.orderInfo.orderId)
          .then(function(response) { 
            if (
              response.data && 
              response.data.code == 1
            ) {
                clearInterval(self.timer2)
                clearInterval(self.timer)
                self.MM='00'
                self.ss='00'
                self.orderInfo.isPay=true
            }
          }) 
      }, 2000);
    }
  }
};
</script>
<style scoped>
@charset "UTF-8";
html {
  font-family: "helvetica neue", tahoma, arial, "hiragino sans gb",
    "microsoft yahei", "Simsun", sans-serif;
  height: 100%;
}

body,
div,
h1,
h2,
img {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
}
.qrcode_page {
  background: #363636;
  height: 100%;
  margin: 0 auto;
}

.container {
  width: 500px;
  height: 95%;
  margin: 0 auto;
  background: url("../images/bg.png") no-repeat center top;
  background-size: 100% auto;
  display: block;
}

.container .logo {
  margin: 0 auto;
  display: block;
  height: 126px;
  line-height: 126px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: white;
}

.container img {
  width: 100%;
  height: auto;
  display: block;
}

.container .box {
  margin: 0 auto;
  width: 100%;
  background: url("../images/box.png") center top;
  background-size: 100% auto;
  text-align: center;
  position: relative;
}

#orderSN_data .orderSN_data_No {
  width: 70%;
  height: 100%;
  line-height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  display: inline-block;
}
#orderSN_data .orderSN_data_copy {
  display: inline-block;
  height: 100%;
  line-height: 100%;
  width: 15%;
  font-size: 15px;
  color: #1e9fff;
}

.h300 {
  min-height: 300px;
  padding: 5px 0;
}

.h250 {
  min-height: 250px;
}

.container .box h1 {
  font-size: 1.25rem;
}

.container .box h1 span {
  font-size: 3.2rem;
  line-height: 3.2rem;
}

/* .container .box h2{
	font-size: 1.25rem;
	line-height: 2.4rem;
} */

#leftCaption {
  width: 20px;
  position: absolute;
  left: 12%;
  top: 50px;
}
#leftCaption .leftCaption1 {
  color: red;
  font-weight: bold;
}
#leftCaption .leftCaption2 {
  color: red;
  font-weight: bold;
}
#rightCaption {
  width: 20px;
  position: absolute;
  right: 12%;
  top: 50px;
}
#rightCaption .rightCaption1 {
  color: red;
  font-weight: bold;
}
#rightCaption .rightCaption2 {
  color: red;
  font-weight: bold;
}

#qrcode {
  position: relative;
  margin: 0 auto;
}

.box .tip {
  width: 100%;
  font-size: 1.1rem;
  line-height: 2.4rem;
  color: #999999;
}

.box strong {
  background: #3ec742;
  color: #fff;
  line-height: 36px;
  font-size: 24px;
  font-family: Arial;
  padding: 0 10px;
  border-radius: 5px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
}

.time_dot {
  color: #3ec742;
  font-size: 24px;
  margin-right: 10px;
  margin-left: 10px;
}

.red {
  color: #ff0000;
}

.container_msg {
  width: 500px;
  height: 95%;
  margin: 0 auto;
  background-color: #fff;
  display: block;
}

.title {
  margin-top: 30px;
  margin-bottom: 18px;
  font-size: 22px;
  color: #333;
}

.title_amount {
  margin-top: 30px;
  margin-bottom: 18px;
  font-size: 32px;
  color: #333;
}

.discription,
.title,
.title_amount {
  text-align: center;
  font-family: PingFangSC-Regular;
}

.discription {
  font-size: 14px;
  color: #999;
}
.reScan {
  margin-top: 18%;
  margin-bottom: 10%;
  padding-left: 20px;
  padding-right: 20px;
}

.am-button {
  -webkit-box-sizing: border-box;
  display: inline-block;
  width: 100%;
  padding: 0 4px;
  height: 47px;
  line-height: 47px;
  font-size: 18px;
  text-align: center;
  border-radius: 4px;
  -webkit-background-clip: padding-box;
  border: 0;
}
.am-button.dynamic.processing:after {
  display: block;
  top: 50%;
  left: 50%;
  margin: -9px;
  -webkit-animation: rotate linear 1s infinite;
  content: " ";
}
.am-button[type="button"] {
  outline: 0;
  -webkit-appearance: none;
}
.am-button,
.am-button.blue {
  border: 0;
  color: #fff;
  background-color: #108ee9;
}
.am-button.blue.hover,
.am-button.blue:active,
.am-button.hover,
.am-button:active {
  color: #fff;
  background-color: #1284d6;
}

.icon {
  margin-top: 15%;
  margin-bottom: 10px;
  text-align: center;
  width: 100%;
}

.icon_core {
  margin-top: 3%;
  margin-bottom: 20px;
  text-align: center;
  width: 100%;
}

.icon img,
icon_core {
  width: 50%;
  height: 50%;
}

@media screen and (max-width: 750px) {
  .qrcode_page {
    background: #f73118;
  }

  .container,
  .container_msg {
    width: 100%;
    min-width: 300px;
    height: 100%;
  }

  .container .box h1 span {
    font-size: 2.4rem;
    line-height: 2.4rem;
  }

  .container .logo {
    margin: 0 auto;
    height: 92px;
    line-height: 92px;
    font-size: 16px;
  }
}

.ico-scan_wecaht_qr {
  display: inline-block;
  width: 56px;
  height: 55px;
  /* background: url("../images/wechat_qr_scan.png") 0 0 no-repeat; */
  vertical-align: middle;
  *display: inline;
  *zoom: 1;
}

.foot {
  width: 80%;
  background: #ffffff;
  text-align: center;
  margin: 30px auto;
  color: #888888;
  font-size: 1rem;
  line-height: 20px;
  font-family: "simsun";
}

#loading {
  width: 230px;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#loading .load-text {
  position: relative;
  width: 180px;
  font-size: 14px;
  line-height: 36px;
}

.loading {
  position: relative;
  border: 3px solid #01a9f4;
  border-right: 3px solid #fff;
  border-bottom: 3px solid #fff;
  height: 50px;
  width: 50px;
  display: block;
  border-radius: 50%;
  -webkit-animation: loading 2s infinite linear;
  -moz-animation: loading 2s infinite linear;
  -o-animation: loading 2s infinite linear;
  animation: loading 2s infinite linear;
  margin: 10px auto;
}
@-webkit-keyframes loading {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@-moz-keyframes loading {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(360deg);
  }
}
@-o-keyframes loading {
  from {
    -o-transform: rotate(0deg);
  }
  to {
    -o-transform: rotate(360deg);
  }
}
@keyframes loading {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>